import { render, staticRenderFns } from "./iFrameForPayment.vue?vue&type=template&id=3b47f328&"
import script from "./iFrameForPayment.vue?vue&type=script&lang=js&"
export * from "./iFrameForPayment.vue?vue&type=script&lang=js&"
import style0 from "./iFrameForPayment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports